
export default {
    en : require('./en/validation').default,
}



// WEBPACK FOOTER //
// ./lang/validations.js